import { renderLegacyAddress } from '../../../../../../common/helpers'

const AddressCell = (props) => renderLegacyAddress(props.location.addressObject)

export default AddressCell
